<template>
  <HeaderDashboardCards
    data-testid="employees-header-dashboard"
    aria-label="Employees summary"
    :metrics="cards"
    variant="count-only"
    :columns="cards.length === 5 ? 5 : 4"
    :action-label="activeIndicator ? 'Clear Filter' : 'Apply Filter'"
    @select="handleSelect"
  />
</template>

<script setup>
import { computed } from "vue";
import HeaderDashboardCards from "@components/HeaderDashboardCards/HeaderDashboardCards.vue";

const props = defineProps({
  activeCount: {
    type: Number,
    default: 0,
  },
  noAccessCount: {
    type: Number,
    default: 0,
  },
  draftCount: {
    type: Number,
    default: 0,
  },
  activeNoPrimaryPositionCount: {
    type: Number,
    default: 0,
  },
  activeNoPrepareForCount: {
    type: Number,
    default: 0,
  },
  /**
   * Key of the card whose filter combination is currently applied to the list.
   * Used for the pressed state only; clicking an active card again resets to the
   * default filter state.
   */
  activeIndicator: {
    type: String,
    default: null,
    validator: (v) =>
      v === null ||
      ["active", "no-access", "draft", "no-primary-position", "no-prepare-for"].includes(v),
  },
  /** When false (product Readiness off), hide the Not Assigned to Prepare for card. */
  showPrepareForCard: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["select-indicator"]);

const cards = computed(() => {
  const all = [
    { key: "active", title: "Active", count: props.activeCount },
    { key: "no-access", title: "No Access", count: props.noAccessCount },
    { key: "draft", title: "Draft", count: props.draftCount },
    {
      key: "no-primary-position",
      title: "Not Assigned to Primary",
      count: props.activeNoPrimaryPositionCount,
    },
    {
      key: "no-prepare-for",
      title: "Not Assigned to Prepare for",
      count: props.activeNoPrepareForCount,
    },
  ].map((card) => ({
    ...card,
    clickable: true,
    active: card.key === props.activeIndicator,
  }));
  return props.showPrepareForCard ? all : all.filter((card) => card.key !== "no-prepare-for");
});

function handleSelect(key) {
  emit("select-indicator", key);
}
</script>
